class ProductImages extends HTMLElement {
  constructor() {
    super();

    this.currentThumbIndex = 0;

    this.images = this.querySelectorAll(".product-image");
    this.thumbs = this.querySelectorAll(".image-thumbnail");

    this.btnNext = this.querySelector("#product-thumb-next");
    this.onNextClick = this.nextImage.bind(this);
    this.btnNext.addEventListener("click", this.onNextClick);

    this.onThumbClick = this.handleThumbClick.bind(this);

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onThumbClick);
    });

    // get the currentThumbIndex by finding the .product-image.active element and getting its data-index
    const activeImage = this.querySelector(".product-image.active");
    if (activeImage) {
      this.currentThumbIndex = parseInt(activeImage.dataset.index);
      this.changeActiveThumb();
      this.changeActiveImage(false);
    }
  }

  changeToVariantImage(variantId) {
    console.log("changeToVariantImage", variantId);
    // find this.images with data-variant-id = variantId, and get its index and set this.currentThumbIndex to that index
    this.images.forEach((image, index) => {
      if (parseInt(image.dataset.variantId) === variantId) {
        this.currentThumbIndex = index;
      }
    });

    this.changeActiveThumb();
    this.changeActiveImage();
  }

  handleThumbClick(evt) {
    const thumb = evt.target;

    const thumbIndex = parseInt(thumb.id.replace("product-thumb-", "")) - 1;

    this.currentThumbIndex = thumbIndex;
    this.changeActiveThumb();
    this.changeActiveImage();
  }

  nextImage(evt) {
    this.currentThumbIndex = this.currentThumbIndex + 1;
    if (this.currentThumbIndex >= this.thumbs.length) {
      this.currentThumbIndex = 0;
    }
    this.changeActiveThumb();
    this.changeActiveImage();
  }

  changeActiveThumb() {
    this.thumbs.forEach((thumb, index) => {
      if (index === this.currentThumbIndex) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });

    const thumb = this.thumbs[this.currentThumbIndex];

    thumb.scrollIntoView({
      block: "end",
      inline: "nearest",
    });
  }

  changeActiveImage(animate = true) {
    const container = document.getElementById("product-images-slider");
    const image = this.images[this.currentThumbIndex];

    const containerRect = container.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();

    const scrollLeft =
      container.scrollLeft + (imageRect.left - containerRect.left);

    if (animate) {
      requestAnimationFrame(() => {
        container.scrollTo({
          left: scrollLeft,
          behavior: "smooth",
        });
      });
    } else {
      container.scrollTo({
        left: scrollLeft,
        behavior: "auto",
      });
    }
  }
}

customElements.define("product-images", ProductImages);
